/**
 * IndicatorPlaceholder - Dashed-border container indicating a future
 * quantitative indicator. Clearly labeled as awaiting spec.
 */

import { FlaskConical } from 'lucide-react';
import { cn } from '@/lib/infra/utils';

interface IndicatorPlaceholderProps {
  label: string;
  className?: string;
}

export function IndicatorPlaceholder({ label, className }: IndicatorPlaceholderProps) {
  return (
    <div
      className={cn(
        'border-border/50 flex items-center gap-2 rounded-lg border border-dashed px-3 py-2',
        className
      )}
    >
      <FlaskConical
        size={14}
        className="text-muted-foreground/50 shrink-0"
      />
      <div className="min-w-0">
        <div className="text-muted-foreground text-[10px] font-medium uppercase tracking-wider">
          {label}
        </div>
        <div className="text-muted-foreground/60 text-[9px]">Placeholder — Awaiting Quant Spec</div>
      </div>
    </div>
  );
}
